<script setup lang="ts">
interface Props {
  color: 'main' | 'accent' | 'error' | 'error-strong' | 'gray' | 'warning'
}
defineProps<Props>()
</script>

<template>
  <div
    v-if="color === 'main'"
    class="plan-tag bg-text-bg-main or-ft-main nowrap omit-long-text"
  >
    <slot />
  </div>
  <div
    v-else-if="color === 'accent'"
    class="plan-tag bg-text-bg-accent or-ft-accent nowrap omit-long-text"
  >
    <slot />
  </div>
  <div
    v-else-if="color === 'error'"
    class="plan-tag bg-text-bg-error or-ft-error nowrap omit-long-text"
  >
    <slot />
  </div>
  <div
    v-else-if="color === 'error-strong'"
    class="plan-tag bg-error or-ft-white nowrap omit-long-text"
  >
    <slot />
  </div>
  <div
    v-else-if="color === 'gray'"
    class="plan-tag bg-gray-3-fill or-ft-gray-2 nowrap omit-long-text"
  >
    <slot />
  </div>
  <div
    v-else-if="color === 'warning'"
    class="plan-tag bg-text-bg-warning or-ft-warning nowrap omit-long-text"
  >
    <slot />
  </div>
</template>

<style scoped>
/* Playground の pg-overline に合わせたピル形状。色/背景は variant ごとのクラスで指定 */
.plan-tag {
  display: inline-flex;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.14em;
  padding: 4px 10px;
  border-radius: 999px;
}
</style>
